import { client } from '../client';
import { getData } from '../apiUtils';
import { Endpoints } from '../endpoints';

export const refreshToken = async (token: string) => client.post(Endpoints.refreshToken, { token }).then(getData);
